export default __webpack_public_path__ + "media/images/features/ja/main_box_title-0fd2762faeae10e215f4081c0c15a022.png";